export default "__VITE_ASSET__BM60Eknr__"